import { t } from "@/i18n-js/instance";
import { ListingCard } from "../ListingCard";

interface AccessGroupListCardProps {
  resources: Array<{ name: string; id: string }>;
}

export const AccessGroupListCard = ({
  resources,
}: AccessGroupListCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.access_groups")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_access_groups_found")}
    renderItem={accessGroup => (
      <span className="font-bold">{accessGroup.name}</span>
    )}
    getItemKey={accessGroup => accessGroup.id}
  />
);
